export const MAILSTER_FORM_ID = 21

export const MAILSTER_FORM_URL = `https://www.dreamfoxmedia.com/mailster/form?id=${MAILSTER_FORM_ID}&style=1`
